"use client";
import { useState } from "react";
import { InputNumber, RangeSlider } from "rsuite";
import styles from "./slider.module.scss";
type Props = {
  onChange?: (value: [number, number]) => void;
};

const CustomSlider = ({ onChange }: Props) => {
  const [value, setValue] = useState<[number, number]>([50000, 90000000]);

  return (
    <div className={styles.slider}>
      <div className={styles.inputGroup}>
        <InputNumber
          min={50000}
          max={99500000}
          value={value[0]}
          onChange={(nextValue: any) => {
            const [start, end] = value;
            if (nextValue > end) {
              return;
            }
            setValue([nextValue, end]);
            if (onChange) {
              onChange([nextValue, end]);
            }
          }}
        />
        <span>-</span>
        <InputNumber
          min={50000}
          max={99500000}
          value={value[1]}
          onChange={(nextValue: any) => {
            const [start, end] = value;
            if (start > nextValue) {
              return;
            }
            setValue([start, nextValue]);
            if (onChange) {
              onChange([start, nextValue]);
            }
          }}
        />
      </div>
      <div className={styles.range}>
        <RangeSlider
          progress
          value={value}
          min={50000}
          max={99500000}
          onChange={(value) => {
            setValue(value);
            if (onChange) {
              onChange(value);
            }
          }}
        />
      </div>
    </div>
  );
};

export default CustomSlider;
